import { render } from "./Videos.vue?vue&type=template&id=60c61685"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__